import { connect } from 'dva';
import DocumentWarning from '../../shared/Document/DocumentWarning';

import { createSelector } from 'reselect';
import {
  getSpousePassportDueDate,
  getSpousePassportStatus,
} from '../../../selectors/spouse';
import { PersonFields } from '../../../models/person';
import { PassportWarning } from '../../../constants/document';

const mapStateToProps: (state: {
  spouse: PersonFields;
}) => PassportWarning = createSelector(
  getSpousePassportStatus,
  getSpousePassportDueDate,
  (status, passportDueDate) => {
    return {
      status,
      passportDueDate,
    };
  }
);

export default connect(mapStateToProps)(DocumentWarning);
